import { Page } from "components/page/page.component";
import { View } from "components/view/view.component";
import { Text } from "components/text/text.component";
import style from './dashboard.restaurant.santander.page.module.css'
import { useGetSantanderRestaurantsDashboardDataApi } from "api/dashboard.api";
import { PieCard } from "components/pieCard/pieCard.component";
import { useEffect } from "react";
import { OccupationCountGraphicComponent } from "components/graphic/santander/occupation.count.graphic.component";
import { toDateMonthYearHourMinuteString, toDateMonthYearString, toHourMinuteString } from "utils/date.util";
import { MAX_SANTANDER_RESTAURANT_CAPACITY } from "data/santander.data";
import { RestaurantCardComponent } from "components/restaurantCard/restaurantCard.component";

export function DashboardRestaurantSantanderPage() {

    const {data, get} = useGetSantanderRestaurantsDashboardDataApi()

    useEffect(()=>{
        // Executa imediatamente
        console.log('Fetching data...', new Date())
        get()
        
        // Configura para executar a cada minuto (60000ms)
        const interval = setInterval(() => {
            console.log('Fetching data...', new Date())
            get()
        }, 60000);
        
        // Limpa o interval quando o componente for desmontado
        return () => clearInterval(interval);
    // eslint-disable-next-line
    },[])

    return <Page menu header title='Dashboard - Restaurante'>
        <View className={style.RestaurantDashboardContainer}>
            {/* {loading ? <><PieCard loading /> <PieCard loading /> </> :  */
            <>
                <View className={style.CardsContainer}>
                    <View style={{width: '100%', textAlign: 'center', marginBottom: '8px'}}>
                        <Text type='h3'>{`Última atualização: ${data?.date ? toDateMonthYearHourMinuteString(data.date) : ''}`}</Text>
                    </View>
                    <View style={{width: '100%', display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '16px', justifyContent: 'center', alignItems: 'center'}}>
                        <RestaurantCardComponent title="Restaurante" value={data?.cards.find(card => card.id === 'restaurante')?.value} total={MAX_SANTANDER_RESTAURANT_CAPACITY} />
                        {/* <RestaurantCardComponent title="Restaurante" value={537} total={MAX_SANTANDER_RESTAURANT_CAPACITY} /> */}
                        {/* <PieCard title="Restaurante" value={data?.cards.find(card => card.id === 'restaurante')?.value} max={MAX_SANTANDER_RESTAURANT_CAPACITY} /> */}
                        <PieCard title="Sala de Marmitas" value={data?.cards.find(card => card.id === 'sala-de-marmitas')?.value} max={data?.cards.find(card => card.id === 'sala-de-marmitas')?.value} />
                    </View>
                </View>
                <View style={{width: '100%', display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '16px', justifyContent: 'center', alignItems: 'center', marginTop: '16px'}}>
                    <OccupationCountGraphicComponent 
                        title={`${data?.date ? `${toDateMonthYearString(data?.date)} - ` : ''}Ocupação durante o dia`} 
                        showLegends 
                        labels={data?.graphicIndicators.labels.map(_ => toHourMinuteString(_)) ?? []} 
                        restauranteValues={data?.graphicIndicators.restauranteValues ?? []} 
                        salaDeMarmitasValues={data?.graphicIndicators.salaDeMarmitasValues ?? []} 
                        showReferenceLines
                        showReferenceLinesLegends
                        referenceValue={MAX_SANTANDER_RESTAURANT_CAPACITY}
                    />
                </View>
            </>}
        </View>
    </Page>
}